import {gql} from '@apollo/client'
import {useMemo} from 'react'
import {CustomEventProperties} from '../common/types'
import {useCustomEventConfigsListQuery} from './generated/use-custom-events'

export const useCustomEvents = (
  organisationId: string,
  environmentId: string
) => {
  const {data: customEventConfigData, loading} = useCustomEventConfigsListQuery(
    {variables: {organisationId, environmentId}}
  )

  const eventConfigMappings: Record<string, CustomEventProperties> = useMemo(
    () =>
      customEventConfigData?.customEventConfigList?.nodes.reduce(
        (acc, curr) => ({...acc, [curr.name]: curr.properties}),
        {}
      ) ?? {},
    [customEventConfigData?.customEventConfigList?.nodes]
  )

  return [eventConfigMappings, loading, customEventConfigData] as const
}

// eslint-disable-next-line functional/immutable-data
useCustomEvents.fragments = {
  customEventConfigsDetail: gql`
    fragment CustomEventConfigsDetail on CustomEventConfig {
      id
      name
      created
      properties
    }
  `
}

gql`
  query CustomEventConfigsList(
    $organisationId: String!
    $environmentId: String!
  ) {
    customEventConfigList(
      organisationId: $organisationId
      environmentId: $environmentId
    ) {
      nodes {
        ...CustomEventConfigDetail
      }
      totalCount
    }
  }
  ${useCustomEvents.fragments.customEventConfigsDetail}
`
